import { fromJS } from 'immutable';
import actions from '../constants';

const initialState = fromJS({
  loggedIn: false,
});

const update = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOGON_START:
    case actions.LOGOFF_FINISH:
      return state.set('loggedIn', false)
        .delete('errorMessage')
        .delete('me');
    case actions.LOGON_ERROR:
      return state.set('loggedIn', false).set('errorMessage', action.error).delete('me');
    case actions.LOGON_FINISH:
      return state.set('loggedIn', true)
        .delete('errorMessage')
        .set('me', fromJS(action.payload));
    default:
      return state;
  }
};

export default update;



// WEBPACK FOOTER //
// ./src/modules/auth/reducers/index.js